/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ISlotGamePlayResult, ISpinData } from './Object/BaseGamePlayResult';
import IPlayResultData from './Object/IPlayResultData';
import { IPlayResult } from './Object/PlayResult';

/**
 * Convenience wrapper for accessing play result data returned from the RGS.
 */
export class PlayResultData implements IPlayResultData
{
    /** The raw response data from the RGS. */
    public PlayResult: IPlayResult;
    constructor(playResult: IPlayResult)
    {
        this.PlayResult = playResult;
    }

    /**
     * @returns The result data for the normal spin.
     */
    public GetBaseGameResult(): ISlotGamePlayResult
    {
        return (this.PlayResult && this.PlayResult.BaseGamePlayResult)
                    ? this.PlayResult.BaseGamePlayResult.SlotGamePlayResult
                    : null;
    }

    /**
     * @returns The result data for any bonus spin.
     */
    public GetBonusGameResult(): ISlotGamePlayResult
    {
        return this.PlayResult.BonusGamePlayResult.SlotGamePlayResult;
    }

    public GetBaseSpinData(): ISpinData
    {
        return this.PlayResult && this.PlayResult.BaseGamePlayResult
            ? this.PlayResult.BaseGamePlayResult.SpinData
            : null;
    }

    public GetBonusSpinData(): ISpinData
    {
        return this.PlayResult && this.PlayResult.BonusGamePlayResult
            ? this.PlayResult.BonusGamePlayResult.SpinData
            : null;
    }

    /**
     * @returns The result data for current game type.
     */
    public GetCurrentGameResult(): ISlotGamePlayResult
    {
        return this.IsBonusSpinActive()
            ? this.GetBonusGameResult()
            : this.GetBaseGameResult();
    }

    /**
     * @returns Any bonus game flag present.
     */
    public GetBonusFlag(): number
    {
        return this.PlayResult.BonusGameFlag;
    }

    /**
     * @returns If any bonus spin is active.
     */
    public IsBonusSpinActive(): boolean
    {
        if (this.HasBonus())
        {
            let bonusResult: ISlotGamePlayResult = this.GetBonusGameResult();
            if (bonusResult != null)
            {
                let spinData: ISpinData = this.PlayResult.BonusGamePlayResult.SpinData;

                if (spinData && spinData.eActivationStatus !== 0) { return true; }

                if (this.PlayResult.BonusGamePlayResult.CurrentOutcome !== undefined)
                {
                    return this.PlayResult.BonusGamePlayResult.CurrentOutcome !== null;
                }
            }
        }

        return false;
    }

    /**
     * @returns Does this game have a bonus flag.
     */
    public HasBonus(): boolean
    {
        return this.GetBonusFlag() !== 0;
    }

    /**
     * @returns The number of remaining spins in the bonus game.
     */
    public GetRemainingSpins(): number
    {
        let curSpin: number = this.PlayResult.BonusGamePlayResult.SpinData.nPlayNumber;
        let totalSpins: number = this.PlayResult.BonusGamePlayResult.SpinData.nTotalPlays;
        return totalSpins - curSpin;
    }
}
